import ExportCourseCodeReportData from './ExportCourseCodeReportData';

export default ExportCourseCodeReportData;
